import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';



const PrivateRoute = ({ component: Component, auth, currentUser: { user: {usertype} = '' }, userType, ...rest }) => (

    <Route
    {...rest}
    render={props => 
      userType === usertype || usertype === 'ADMIN' ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  currentUser: state.auth.currentUser
});

export default connect(mapStateToProps)(PrivateRoute);
